import { OPEN_TSCANS_IMPORT_MODAL } from 'modules/interventions/actionTypes';
import * as types from 'modules/tireScan/actionTypes';
import type { ImportSource } from 'modules/tireScan/constants';
import type { FetchTireScansSuccessAction } from 'modules/tireScan/types';
import { createReducer, sourceMatcher } from 'utils/ReduxUtils';

const initialState = false;

const onSuccess = (state: boolean, { payload }: FetchTireScansSuccessAction): boolean => payload.hasMore;

const reset = (): boolean => initialState;

const reducer = (source: ImportSource) =>
  createReducer<boolean>(initialState, {
    [types.FETCH_TIRE_SCAN_SUCCESS]: sourceMatcher(source, onSuccess),
    [OPEN_TSCANS_IMPORT_MODAL]: reset,
  });

export default reducer;
